/** @jsxImportSource @emotion/react */
import { retriveApi } from "api/retrive";
import { IconNotification } from "assets/mobile/icons/home-page";
import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { TypeMarquee } from "types/retrive";

import { MarqueeStyle } from "./index.style";

const MarqueeCustom = () => {
  const [data, setData] = useState<Array<TypeMarquee>>([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const response = await retriveApi.getMarquee();

    setData(response.data);
  };
  return (
    <div css={MarqueeStyle.index}>
      <div css={MarqueeStyle.notiLeft}>
        <IconNotification />
        <span>TIN TỨC</span>
      </div>
      <Marquee css={MarqueeStyle.marquee} pauseOnHover speed={20} autoFill>
        {data?.map((item, key) => (
          <span className="item" key={key}>
            {item.title}
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default MarqueeCustom;
